import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Club Repairs. /club/repairs. Each repair references a member by memberId.
//   {id}: { memberId, phone, club, manufacturer, repairRequested, shaft, grip,
//           lieAdj, loftAdj, parts, labor, dueDate, status, photos, notes,
//           stageHistory, createdAt }
const BASE = 'club/repairs'
export const REPAIR_STAGES = ['Received', 'In Progress', 'Ready for Pickup', 'Picked Up', 'Paid']
const today = () => new Date().toISOString().slice(0, 10)
const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0)

export function watchRepairs(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }

export async function createRepair(d) {
  const club = String(d.club || '').trim()
  if (!club) throw new Error('Club / item is required.')
  const node = push(tref(BASE))
  await set(node, {
    id: node.key,
    memberId: d.memberId || null,
    phone: String(d.phone || '').trim(),
    club,
    manufacturer: String(d.manufacturer || '').trim(),
    repairRequested: String(d.repairRequested || '').trim(),
    shaft: String(d.shaft || '').trim(),
    grip: String(d.grip || '').trim(),
    lieAdj: String(d.lieAdj || '').trim(),
    loftAdj: String(d.loftAdj || '').trim(),
    parts: num(d.parts),
    labor: num(d.labor),
    dueDate: d.dueDate || '',
    notes: String(d.notes || '').trim(),
    photos: String(d.photos || '').trim(),
    status: 'Received',
    stageHistory: { Received: today() },
    createdAt: Date.now(),
  })
  logActivity({ type: 'repair', memberId: d.memberId || null, icon: '🔧', text: `Repair received: ${club}${d.manufacturer ? ` (${d.manufacturer})` : ''}` })
  return node.key
}

export async function updateRepair(id, patch) {
  const clean = {}
  for (const k of ['phone', 'club', 'manufacturer', 'repairRequested', 'shaft', 'grip', 'lieAdj', 'loftAdj', 'dueDate', 'notes', 'photos']) if (patch[k] != null) clean[k] = String(patch[k]).trim()
  if (patch.memberId !== undefined) clean.memberId = patch.memberId || null
  if (patch.parts !== undefined) clean.parts = num(patch.parts)
  if (patch.labor !== undefined) clean.labor = num(patch.labor)
  await update(tref(`${BASE}/${id}`), clean)
}

export async function setRepairStatus(id, status, memberId, club) {
  await update(tref(`${BASE}/${id}`), { status, [`stageHistory/${status}`]: today() })
  logActivity({ type: 'repair', memberId: memberId || null, icon: '🔧', text: `Repair ${status.toLowerCase()}: ${club || 'club'}` })
}

export async function deleteRepair(id) { await remove(tref(`${BASE}/${id}`)) }
